import { Fragment, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FaLock } from 'react-icons/fa'

import { categorizeFonts } from '../utils/categorizeFonts.ts'

interface FontModal extends ModalProps {
  fonts: Font[]
  subscription: string | null | undefined
  onChoose: (fontId: number, isPremium: boolean) => void
  showModal: boolean
}

export const FontsModal = ({ onChoose, fonts, subscription }: FontModal) => {
  const { t } = useTranslation()
  const { watch } = useFormContext<DesignFormFields>()

  const [searchQuery, setSearchQuery] = useState('')
  const [filteredFonts, setFilteredFonts] = useState<
    { title: string; fonts: Font[] }[]
  >([])

  // Update filteredFonts when searchQuery changes
  useEffect(() => {
    const filtered = fonts.filter((font) =>
      font.display.toLowerCase().includes(searchQuery.toLowerCase()),
    )

    const sortedFonts = categorizeFonts(filtered)
    const fontsData = [
      { title: t('arabic'), fonts: sortedFonts?.arabic || [] },
      { title: t('classic'), fonts: sortedFonts?.classic || [] },
    ]
    setFilteredFonts(fontsData)
  }, [searchQuery, fonts, t])

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value)
  }

  return (
    <div className="flex flex-col p-4 h-96 overflow-hidden overflow-y-auto">
      <p className="mb-5 text-center text-2xl">{t('selectFont')}</p>

      <input
        value={searchQuery}
        onChange={handleSearchChange}
        placeholder="Search"
        className="focus:ring-primary-500 order-blue-500 mb-5 w-full rounded-md border px-4 py-2 text-sm placeholder-black shadow-md focus:border-blue-600 focus:outline-none focus:ring-2"
      />

      {filteredFonts.length > 0 &&
        filteredFonts.map(({ title, fonts }, index) => (
          <Fragment key={index}>
            <p className="font-medium">{title}</p>
            <ul>
              {fonts.map(({ id, display, premium }) => (
                <li
                  key={id}
                  onClick={() => onChoose(id, premium)}
                  className={`flex cursor-pointer justify-between rounded-lg p-2 ${watch().fontId === id ? 'bg-[#f2f2f2]' : ''} `}
                >
                  <span>{display}</span>
                  {!subscription && premium && <FaLock color="#000000" />}
                </li>
              ))}
            </ul>
            {index === 0 && (
              <div className="my-1 h-[1px] w-full bg-[#c2c2c2]"></div>
            )}
          </Fragment>
        ))}
    </div>
  )
}
